// 瓜核社内容数据（演示用虚构场景）
// 站点栏目分类
export const categories = [
  "全部",
  "娱乐圈",
  "网红达人",
  "社会热点",
  "体育赛事",
  "商业人物",
];

// 可信度评级标签
export const verdictOptions = ["实锤", "存疑", "辟谣"];

export const heroTicker = [
  "「某顶流商务报价翻三倍」今日实锤，证据链含 3 份合同比对",
  "「千万级博主数据造假」查证中，已收到 47 条补充线索",
  "「综艺补录风波」二次复核结束，维持存疑评级",
  "「俱乐部转会传闻」已辟谣，原始截图被指为旧图",
  "「品牌代言解约传闻」进度更新：时间线已补齐至昨日",
];

export const stats = [
  { key: "累计核实", value: "1287", suffix: "条", note: "自上线以来" },
  { key: "本月新增", value: "96", suffix: "条", note: "持续跟进中" },
  { key: "实锤占比", value: "43", suffix: "%", note: "多方信源确认" },
  { key: "辟谣打假", value: "312", suffix: "条", note: "还原真相" },
  { key: "平均核验", value: "6.2", suffix: "小时", note: "快速出结论" },
];

export const cases = [
  {
    id: "c1",
    title: "顶流男团成员被曝隐婚生子，工作室回应前后矛盾",
    category: "娱乐圈",
    verdict: "实锤",
    score: 92,
    excerpt:
      "爆料称其已在海外登记并育有一子，两版声明时间与措辞存在可交叉验证的差异，多方信源与证件类线索指向一致。",
    sources: 9,
    channels: ["工作室声明", "登记信息比对", "航班行程", "合作方证词"],
    tags: ["顶流", "隐婚", "声明矛盾"],
    dateLabel: "今日更新",
    icon: "ri-gemini-line",
  },
  {
    id: "c2",
    title: "千万粉丝博主被指搬运他人原创视频并买热搜",
    category: "网红达人",
    verdict: "实锤",
    score: 88,
    excerpt:
      "两则视频逐帧比对存在明显重叠，发布时间戳与被搬运账号操作日志吻合，平台与原作者均已确认侵权属性。",
    sources: 11,
    channels: ["逐帧比对", "时间戳", "平台后台", "原作者确认"],
    tags: ["搬运", "洗稿", "买热搜"],
    dateLabel: "昨日更新",
    icon: "ri-clapperboard-line",
  },
  {
    id: "c3",
    title: "头部主播被曝直播带货价格高于官方渠道",
    category: "网红达人",
    verdict: "存疑",
    score: 54,
    excerpt:
      "对比样本时段与品类不一致，部分截图截取的是活动预热价，无法判定是否构成「破价承诺」失真，仍在收集全程录屏。",
    sources: 5,
    channels: ["价格快照", "活动规则", "客服口径"],
    tags: ["直播", "价格", "破价"],
    dateLabel: "跟进中",
    icon: "ri-price-tag-3-line",
  },
  {
    id: "c4",
    title: "当红女演员被曝拍摄期间耍大牌换走合作编剧",
    category: "娱乐圈",
    verdict: "辟谣",
    score: 18,
    excerpt:
      "导演与制片人先后发声，原编剧因档期冲突主动请辞，所谓「换人风波」为后期剪辑名单调整误传，相关聊天截图系拼接。",
    sources: 7,
    channels: ["主创声明", "立项记录", "聊天截图鉴定"],
    tags: ["耍大牌", "换编剧", "拼接图"],
    dateLabel: "已定论",
    icon: "ri-mic-line",
  },
  {
    id: "c5",
    title: "知名球星被曝转会违约金出现「阴阳条款」",
    category: "体育赛事",
    verdict: "实锤",
    score: 85,
    excerpt:
      "对外公布金额与合同中实际解约金存在两套数字，签约方与联赛注册文件互相印证，相关条款已进入复核程序。",
    sources: 6,
    channels: ["注册文件", "签约方", "联赛备案"],
    tags: ["转会", "违约金", "阴阳条款"],
    dateLabel: "本周热点",
    icon: "ri-trophy-line",
  },
  {
    id: "c6",
    title: "某科技公司被曝「融资到账截图」实为内部演示稿",
    category: "商业人物",
    verdict: "辟谣",
    score: 15,
    excerpt:
      "截图水印与演示环境标记被忽略，财务审计口径显示该轮融资仍在交割中，创始人已补充银行回单予以澄清。",
    sources: 8,
    channels: ["银行回单", "审计口径", "演示文件元数据"],
    tags: ["融资", "截图", "演示稿"],
    dateLabel: "已定论",
    icon: "ri-building-2-line",
  },
  {
    id: "c7",
    title: "悬疑剧男二被曝与女主同住酒店电梯出入同框",
    category: "娱乐圈",
    verdict: "存疑",
    score: 47,
    excerpt:
      "同框画面取自同一剧组集中住宿楼层，电梯口偶遇与「恋情」之间证据跨度较大，需进一步确认是否非独处同乘。",
    sources: 4,
    channels: ["路透图", "剧组行程", "楼层名单"],
    tags: ["CP", "同框", "剧组"],
    dateLabel: "跟进中",
    icon: "ri-camera-lens-line",
  },
  {
    id: "c8",
    title: "教育机构被曝「名师团队」仅一人有授课资质",
    category: "社会热点",
    verdict: "实锤",
    score: 90,
    excerpt:
      "宣传海报九人名师的资质信息经逐一核验仅一人可查，其余为运营与教研人员，涉嫌夸大宣传，主管部门已介入。",
    sources: 12,
    channels: ["资质查询", "宣传物料", "在职名单"],
    tags: ["教育", "名师", "资质"],
    dateLabel: "今日实锤",
    icon: "ri-graduation-cap-line",
  },
  {
    id: "c9",
    title: "景区被曝「天价停车费」被指单价多打一个零",
    category: "社会热点",
    verdict: "辟谣",
    score: 22,
    excerpt:
      "收费公示牌与电子小票时间不同期，网传价目为淡季临时围挡旧照，现行标准与官方批复文件一致。",
    sources: 5,
    channels: ["批复文件", "收费小票", "现场实拍"],
    tags: ["景区", "停车费", "旧照"],
    dateLabel: "已定论",
    icon: "ri-roadster-line",
  },
  {
    id: "c10",
    title: "电竞选手被曝训练赛录像遭对手「偷看」",
    category: "体育赛事",
    verdict: "存疑",
    score: 58,
    excerpt:
      "复盘窗口与赛事转播时间存在重叠可能，但无法证明信息传递闭环，需赛事方提供观赛权限日志进一步取证。",
    sources: 6,
    channels: ["复盘日志", "观赛权限", "对战数据"],
    tags: ["电竞", "作弊", "录像"],
    dateLabel: "跟进中",
    icon: "ri-gamepad-line",
  },
];

// 单个案例的取证时间线
export const timelineCase = {
  id: "c1",
  title: "顶流男团成员隐婚生子爆料 · 取证全过程",
  verdict: "实锤",
  score: 92,
  intro:
    "从一条无来源的深夜发帖到多方信源交叉确认，我们用 8 小时拆解并重构了这条传言的证据链，以下是核验每一步的关键节点。",
  items: [
    {
      time: "第 0 小时",
      tag: "收料建档",
      title: "匿名帖抛出「隐婚生子」，零截图零出处",
      desc: "当晚 22:11 一条自称「业内」的帖子冲上广场，无任何影像证据。瓜核社立即建档，标注「待溯源」，并对账号历史进行查重，疑似水军小号。",
      evidence: ["发帖账号历史异常", "无原始影像"],
      status: "collected",
    },
    {
      time: "第 1.5 小时",
      tag: "反向溯源",
      title: "锁定「海外登记」与「孩子出生」两条可核线索",
      desc: "将帖中可验证的具体事实拆为独立线索：海外登记记录、航班轨迹、两版声明。凡不可证伪的模糊描述一律先剔除，防止被情绪带偏。",
      evidence: ["线索拆解 3 条", "剔除模糊项 2 条"],
      status: "trace",
    },
    {
      time: "第 3 小时",
      tag: "交叉核验",
      title: "两版声明措辞差异与登记时间戳互相印证",
      desc: "工作室前后两则声明删改了关键日期表述，登记系统的查询时间范围恰覆盖该改动窗口，形成可交叉验证的闭合链条。",
      evidence: ["声明 A/B 对比", "登记时间戳"],
      status: "verify",
    },
    {
      time: "第 6 小时",
      tag: "信源确权",
      title: "合作方证词与行程日志补充间接佐证",
      desc: "航班与行程日志排除了「通告档期冲突」这一最常见的澄清借口，多位不愿具名的合作方仅确认「时间表对不上」，未越权评价私生活。",
      evidence: ["行程日志", "合作方证词"],
      status: "source",
    },
    {
      time: "第 8 小时",
      tag: "评级公示",
      title: "出具「实锤 · 可信 92」结论并开放复核",
      desc: "证据链完整、无单一信源独挑大梁，予以实锤评级。结论页同步列出所有证据与不足，欢迎当事人提交反证启动二次复核。",
      evidence: ["可信度 92", "开放复核"],
      status: "verdict",
    },
  ],
};

// 求证进行中
export const pendingCases = [
  {
    id: "p1",
    title: "千万级户外主播被指「户外求生」实为棚拍搭景",
    clue: 47,
    brief: "多个角度路透被指与棚内搭景雷同，需比对布光与地形植被，等待原素材时间戳。",
    icon: "ri-remote-control-line",
    tag: "网红达人",
  },
  {
    id: "p2",
    title: "偶像团体被曝粉丝应援费用去向存疑",
    clue: 63,
    brief: "应援资金与公开支出对不上，征集周边销量与账目线索，欢迎官方公示流水。",
    icon: "ri-money-cny-circle-line",
    tag: "娱乐圈",
  },
  {
    id: "p3",
    title: "连锁餐饮被指「现熬汤底」实为半成品调配",
    clue: 29,
    brief: "后厨短拍被反复解读，需核对供应链与门店培训手册，欢迎内部人士匿名补充。",
    icon: "ri-restaurant-line",
    tag: "社会热点",
  },
  {
    id: "p4",
    title: "电竞俱乐部被曝青训选手合同存在竞业限制陷阱",
    clue: 51,
    brief: "选手及家属对合同条款理解不一，征集完整条款摘录与离职沟通记录以便比对。",
    icon: "ri-file-user-line",
    tag: "体育赛事",
  },
];

// 核验流程
export const processSteps = [
  {
    title: "收料建档",
    desc: "收到爆料后先做真实性初筛：标注来源可信度、剔除明显营销号，为每一条线索建立独立档案。",
    icon: "ri-folder-2-line",
  },
  {
    title: "反向溯源",
    desc: "把传言拆成「可验证」与「不可证伪」两类，仅对前者逐一溯源，防止模糊描述引发误判。",
    icon: "ri-search-eye-line",
  },
  {
    title: "交叉核验",
    desc: "坚持多信源互相印证，单一渠道不轻易下结论，官方口径与独立证据缺一不可。",
    icon: "ri-git-merge-line",
  },
  {
    title: "定级公示",
    desc: "按证据强度出具实锤 / 存疑 / 辟谣评级与可信度分值，公示全部证据与不足。",
    icon: "ri-medal-line",
  },
  {
    title: "开放复核",
    desc: "当事人可提交反证，围观者可持续补料，任何新证据都可能在 24 小时内触发二次核验。",
    icon: "ri-refresh-line",
  },
];

// 可信度评级标准
export const scaleLevels = [
  {
    name: "实锤",
    color: "accent",
    range: "证据闭环 · 多方信源",
    desc: "证据链完整可交叉验证，无单一信源独挑大梁，结论具较高可信度。",
  },
  {
    name: "存疑",
    color: "secondary",
    range: "线索存在 · 尚待补证",
    desc: "有一定线索但证据跨度不足或存矛盾，暂时无法定论，持续跟进补证。",
  },
  {
    name: "辟谣",
    color: "primary",
    range: "证伪成立 · 还原真相",
    desc: "原始信息被证实为误传、断章或拼接，已厘清事实并公开澄清路径。",
  },
];

// 用户口碑
export const testimonials = [
  {
    name: "柚子汽水",
    role: "追星吃瓜十年",
    text: "以前看到爆料先上头，现在习惯先来瓜核社查一眼评级。实锤再开吃，存疑先观望，确实少踩不少节奏。",
    icon: "ri-heart-3-line",
  },
  {
    name: "老王的日常",
    role: "关注财经与商业",
    text: "对商界人物类瓜格外受益，能把「截图」和「演示稿」分清楚，至少不会因为一张模糊图就冲上去开骂。",
    icon: "ri-line-chart-line",
  },
  {
    name: "Tina 在追剧",
    role: "娱乐圈吃瓜选手",
    text: "最喜欢的是每个结论都摆证据、也敢承认「还没查到」。这种不装懂的态度，在吃瓜圈真的很难得。",
    icon: "ri-quill-pen-line",
  },
  {
    name: "阿坤不打游戏",
    role: "电竞观众",
    text: "争议事件给双方留足反驳窗口，规则是透明的，看着就比无脑站队舒服。",
    icon: "ri-gamepad-line",
  },
];

// 常见问题
export const faqs = [
  {
    q: "「实锤 / 存疑 / 辟谣」评级是怎么定出来的？",
    a: "评级依据证据链的完整度：实锤需多方信源可交叉验证并形成闭环；存疑指有线索但证据跨度不足或存在矛盾；辟谣则表示原始信息已被证实为误传、断章或拼接，我们公开澄清路径。评级可随新证据在 24 小时内触发二次复核。",
  },
  {
    q: "我该去哪里提交一条有待核实的爆料？",
    a: "在首页「我要求证」板块填写尽可能具体的线索即可：包括事件对象、时间、原始出处、可佐证的图片或链接。信息越具体，溯源越快。为保护隐私，站内不公开投稿人身份，匿名补充同样有效。",
  },
  {
    q: "为什么有的瓜要等很久才有结论？",
    a: "我们会优先处理能够形成证据链的事件。若线索仅来自单一来源、或关键证据暂时无法获取（如官方口径缺位），案件会维持「存疑」并持续跟进，而不是为了速度草率下结论。快固然好，准更重要。",
  },
  {
    q: "当事人/被爆料方想回应或提出反证怎么办？",
    a: "我们为当事双方保留平等反驳窗口，可通过求证入口上传声明或反证材料。复核组会在核查材料真实性后更新评级与时间线，不会因为舆论单边倒而忽略另一侧证据。",
  },
  {
    q: "如何看待网络流传的聊天记录与截图？",
    a: "截图只能作为线索起点而非定论。我们会核验截图元数据、上下文完整性并做拼接痕迹检测，单独一张来源不明的图通常不足以支撑「实锤」，这也是我们把标准守得比较严的原因。",
  },
  {
    q: "内容会不会被水军或营销号利用？",
    a: "平台坚持证据优先、结论留痕，每个评级结论均公示证据来源与核验日志，避免被单一叙事裹挟。若你发现某条结论存在疏漏，欢迎随时提交补充证据推动复核。",
  },
];

// 平台原则
export const principles = [
  {
    title: "证据优先",
    desc: "先问「有没有原始出处」，再谈立场与情绪，结论以证据链为准。",
    icon: "ri-focus-3-line",
  },
  {
    title: "结论留痕",
    desc: "每个评级都公开核验路径与证据清单，错了敢改、能复核。",
    icon: "ri-file-history-line",
  },
  {
    title: "拒绝带节奏",
    desc: "不追逐情绪流量，不预设单边叙事，给当事双方同等反驳机会。",
    icon: "ri-scales-3-line",
  },
];